import { Navigate, Route, Routes} from 'react-router-dom';
import LoginPage from '../../pages/login/LoginPage';

import { useGetProvidersQuery } from '~/services/providers';
import { PATH, SCRIPTS_PATH } from '~/services/endpoints';
import VerifiedScriptPage from '~/pages/scripts/VerifiedScriptPage';
import { SIMPLContract } from '~/pages/contracts/SIMPLContracts';
import PrivateRoute from './privateRoute';
import { SIMPLCloudEnvironment } from '~/pages/cloud/CloudEnviroment';

const MainRouter = () => {
  useGetProvidersQuery();

  return (
    <Routes>
      <Route path={PATH} element={<LoginPage />} />

      <Route
        path={SCRIPTS_PATH}
        element={
          <PrivateRoute>
            <VerifiedScriptPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/contracts"
        element={
          <PrivateRoute>
            <SIMPLContract />
          </PrivateRoute>
        }
      />

       <Route
        path="/cloud-environment"
        element={
          <PrivateRoute>
            <SIMPLCloudEnvironment />
          </PrivateRoute>
        }
      />

      <Route path="*" element={<Navigate to={PATH} />} />
    </Routes>
  );
};

export default MainRouter;

